import React from "react";
import { Pie } from "@ant-design/plots";
import { Title } from "@mantine/core";
const Charts = ({ report, label }) => {
  const PieChartOneConfig = {
    appendPadding: 10,
    data: report,
    angleField: "value",
    colorField: "answer",
    radius: 0.9,
    color: [
      "#ffb630",
      "#aa895b",
      "#9eb237",
      "#48a05c",
      "#008575",
      "#005248",
      "#006774",
      "#2f4858",
      "#402e32",
      "#fe8980",
      "#ffc1b5",
    ],
    label: {
      offset: "-30%",
      type: "inner",
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 15,
        textAlign: "center",
      },
    },

    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
  };
  return (
    <>
      <Title
        order={3}
        size="h2"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {label}
      </Title>
      <Pie {...PieChartOneConfig} />
    </>
  );
};

export default React.memo(Charts);
